import {
    Alert,
    Button,
    FormControl,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    SimpleGrid,
    useToast
} from '@chakra-ui/react';
import { useState } from 'react';
import { updateSubscription } from '../../api';

export default function EditSubscriptionModal({ isOpen, onClose, subscription, onSuccess, subId }) {
    const toast = useToast();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        firstName: subscription?.profile?.paymentProfile?.billTo?.firstName || '',
        lastName: subscription?.profile?.paymentProfile?.billTo?.lastName || '',
        email: subscription?.profile?.email || '',
        cardNumber: '',
        expirationDate: '',
        address: subscription?.profile?.paymentProfile?.billTo?.address || '',
        city: subscription?.profile?.paymentProfile?.billTo?.city || '',
        state: subscription?.profile?.paymentProfile?.billTo?.state || '',
        zip: subscription?.profile?.paymentProfile?.billTo?.zip || '',
        country: subscription?.profile?.paymentProfile?.billTo?.country || '',
        subscriptionId: subId,
        customerProfileId: subscription?.profile?.customerProfileId || '',
        paymentProfileId: subscription?.profile?.paymentProfile?.customerPaymentProfileId || ''
    });

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = async () => {
        setLoading(true);
        const res = await updateSubscription(formData);
        setLoading(false);

        if (res.success) {
            toast({ title: 'Subscription updated.', status: 'success' });
            onSuccess();
            onClose();
        } else {
            toast({ title: 'Update failed.', description: res.error, status: 'error' });
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Edit Subscription - {subId}</ModalHeader>
                <ModalCloseButton />

                <Alert colorScheme='orange' mb={3}>
                    To change anything in this subscription, you will need to enter the card numbers and expiration date, it doesn't have to be same card number
                    it can be a different card
                </Alert>

                <ModalBody>
                    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                        <FormControl>
                            <FormLabel>First Name</FormLabel>
                            <Input name="firstName" value={formData.firstName} onChange={handleChange} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Last Name</FormLabel>
                            <Input name="lastName" value={formData.lastName} onChange={handleChange} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Email</FormLabel>
                            <Input name="email" value={formData.email} onChange={handleChange} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Card Number</FormLabel>
                            <Input name="cardNumber" value={formData.cardNumber} onChange={handleChange} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Expiration Date (MMYY)</FormLabel>
                            <Input name="expirationDate" value={formData.expirationDate} onChange={handleChange} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Address</FormLabel>
                            <Input name="address" value={formData.address} onChange={handleChange} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>City</FormLabel>
                            <Input name="city" value={formData.city} onChange={handleChange} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>State</FormLabel>
                            <Input name="state" value={formData.state} onChange={handleChange} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Zip</FormLabel>
                            <Input name="zip" value={formData.zip} onChange={handleChange} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>Country</FormLabel>
                            <Input name="country" value={formData.country} onChange={handleChange} />
                        </FormControl>
                    </SimpleGrid>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={onClose} mr={3}>Cancel</Button>
                    <Button colorScheme="blue" onClick={handleSubmit} isLoading={loading}>
                        Update
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
